import * as React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  // PinterestIcon,
  // PinterestShareButton,
  // TwitterIcon,
  TwitterShareButton,
  XIcon,
} from 'react-share';

const SocialShare = ({ url, title, description }) => (

  <>
    <FacebookShareButton url={url} quote={description}>
      <FacebookIcon size={40} round={true} />
    </FacebookShareButton>

    <LinkedinShareButton url={url} title={title} summary={description}>
      <LinkedinIcon size={40} round={true} />
    </LinkedinShareButton>

    <TwitterShareButton url={url} title={description}>
      <XIcon size={40} round={true} />
    </TwitterShareButton>

    {/* <PinterestShareButton url={url} title={description}>
      <PinterestIcon size={40} round={true} />
    </PinterestShareButton> */}

  </>
);

export default SocialShare;